module.exports = __webpack_public_path__ + "static/media/dpp.8468a734.svg";